import { ClientError as BaseClientError } from '@dracul/common-frontend'

/**
 * ClientError personalizado para Invira
 * Extiende el ClientError del framework para manejar el formato de errores del backend
 */
class ClientError extends BaseClientError {
    constructor(error) {
        super(error)
        
        // Post-procesar los errores de GraphQL para manejar el formato de inputErrors del backend
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
            this.processInviraInputErrors(error.graphQLErrors)
        }
    }

    processInviraInputErrors(graphQLErrors) {
        graphQLErrors.forEach(gqlError => {
            // Solo procesar errores de validación (BAD_USER_INPUT)
            if (gqlError.extensions && gqlError.extensions.code === 'BAD_USER_INPUT') {
                
                // Usar el mensaje específico del backend en lugar del genérico
                if (gqlError.message) {
                    this.i18nMessage = gqlError.message
                    this.showMessage = gqlError.message
                    // Actualizar también el último mensaje en el array
                    if (this.i18nMessages.length > 0) {
                        this.i18nMessages[this.i18nMessages.length - 1] = gqlError.message
                    }
                }

                // Procesar inputErrors con formato directo de string
                if (gqlError.extensions.inputErrors) {
                    for (let inputError in gqlError.extensions.inputErrors) {
                        const errorValue = gqlError.extensions.inputErrors[inputError]
                        
                        // Si el error es un string directo (formato nuevo del backend)
                        if (typeof errorValue === 'string') {
                            // Reemplazar el inputError procesado por el framework
                            this.inputErrors[inputError] = [errorValue]
                        }
                        // Si no tiene el formato esperado por el framework y no fue procesado
                        else if (!errorValue.properties && !this.inputErrors[inputError]) {
                            this.inputErrors[inputError] = [errorValue.toString()]
                        }
                    }
                }
            }
        })
    }
}

export default ClientError
